import axios from 'axios'
import router from '@/router';
import storage from '@/utils/storage'
import { ElMessage, ElMessageBox } from 'element-plus'

const domain = window.location.hostname;

axios.defaults.baseURL = "http://"+domain+":6688" //请求地址
axios.defaults.timeout = 30 * 1000  //设置超时时间
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'  // post请求头

axios.interceptors.request.use(
    (config) => {
        let token = storage.get("token");
        if (token) {
            config.headers['Authorization'] = token
        }
        return config;
    }
)

// 响应拦截器（处理响应数据）
axios.interceptors.response.use(
    (res) => {
        // 防止出现重复弹窗
        if(document.getElementsByClassName('el-message-box').length > 1) return;
        if(res.data.code == 200) return res;
        if(res.data.code == 444){
            ElMessageBox.confirm(res.data.msg, '出现错误', { showCancelButton:true, type: 'error'}
                ).then((res) =>{
                    router.replace({path: '/login'});
                }).catch((err)=>{ })
        }else{
            
            ElMessage({showClose: true, message: res.data.msg, type: 'error'})
        }
        return Promise.reject(res)
    }, 
    (err) => {  
        ElMessageBox.confirm(err.response.data.msg, '服务器错误', { showCancelButton:true, type: 'error'}
            ).then((res) =>{
                router.replace({path: '/login'});
            }).catch((err)=>{ })
        return Promise.reject(err);
    }
);

// 封装get方法
function get(url, data){
    return new Promise((resolve, reject) =>{
        axios.get(url, data).then(res =>{
            resolve(res.data);
        }).catch(err =>{
            reject(err.data);
        })
    });
}

// 封装post方法
function post(url, params){
    return new Promise((resolve, reject) =>{
        axios.post(url, params).then(res =>{
            resolve(res.data);
        }).catch(err =>{
            reject(err.data);
        })
    });
}

// 封装下载方法，用于导出excel
function download(url, params){
    return new Promise((resolve, reject) =>{
        axios.post(url, params,{responseType: 'blob'}).then(res =>{
            resolve(res);
        }).catch(err =>{
            reject(err.data);
        })
    });
}

//对外接口
export function request({url, method, data}){
    if(method == 'get'){
        return get(url, data);
    }else if(method == 'post'){
        return post(url, data);
    }else if(method == 'download'){
        return download(url, data);
    }
}

export default request